import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { Oauth2Service } from '@bytel/checkout';

import { Observable, of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';

import { TagService } from '../shared/tag/tag.service';
import { PrismeLoggerService } from './../services/prisme-logger.service';
import { CustomerResolver } from './customer.resolver';

@Injectable({
    providedIn: 'root',
})
/**
 * Resolver for payment redirect after younited
 */
export class RedirectResolver {
    private customerResolver: CustomerResolver = inject(CustomerResolver);
    constructor(
        private oauth2Service: Oauth2Service,
        private tagService: TagService,
        private prismeLoggerService: PrismeLoggerService,
    ) {}

    public resolve(route: ActivatedRouteSnapshot): Observable<any> {
        return this.oauth2Service.resolve(route).pipe(
            concatMap(() => this.tagService.initialize()),
            concatMap(() => this.customerResolver.resolve()),
            catchError((err) => {
                this.prismeLoggerService.sendLogToPrisme('Erreur resolver redirect', err);
                return of(null);
            }),
            map(() => of(null)),
        );
    }
}
